import Usuario from './Usuario'
import Tiponotificacao from './Tiponotificacao'
import StatusRemessaCorreio from './StatusRemessaCorreio'
import DomPublicacaoLote from './DomPublicacaoLote'

class LoteRemessaCorreio {
    constructor(
        {
            id = null,
            status_lote_remessa_correio_id = null,
            tipo_notificacao_id = null,
            parametros_correio_id = null,
            ano_lote = null,
            numero_lote = null,
            numero_notificacao_inicial = null,
            numero_notificacao_final = null,
            total_servico_local = null,
            total_servico_estadual = null,
            total_servico_nacional = null,
            data_emissao = null,
            data_postagem = null,
            created_at = null,
            updated_at = null,
            deleted_at = null,
            usuario_id = null,

            data_envio_grafica = null,
            data_envio_correios = null,
            data_envio_grafica_protocolo = null,       

            //ORM
            usuario = {},
            tiponotificacao = {},
            tipo_notificacao = {},
            status_remessa_correio = {},

            //Visualização Log Erro Notificação
            disable_fields = false,
            num_ait_composto = null,
            dom_publicacao_lote = []

        } = {}
    ) {
        this.id = id;
        this.numero_lote = numero_lote;

        this.status_lote_remessa_correio_id = status_lote_remessa_correio_id;
        this.tipo_notificacao_id = tipo_notificacao_id;
        this.parametros_correio_id = parametros_correio_id;
        this.ano_lote = ano_lote;
        
        this.numero_notificacao_inicial = numero_notificacao_inicial;
        this.numero_notificacao_final = numero_notificacao_final;
        this.total_servico_local = total_servico_local;
        this.total_servico_estadual = total_servico_estadual;
        this.total_servico_nacional = total_servico_nacional;
        this.data_emissao = data_emissao;
        this.data_postagem = data_postagem;

        this.created_at = created_at;
        this.updated_at = updated_at;
        this.deleted_at = deleted_at;        
        this.usuario_id = usuario_id;


        this.data_envio_grafica = data_envio_grafica;
        this.data_envio_correios = data_envio_correios;
        this.data_envio_grafica_protocolo = data_envio_grafica_protocolo;  

        //ORM
        this.usuario = usuario ? new Usuario(usuario) : new Usuario();
        this.tiponotificacao = tiponotificacao ? new Tiponotificacao(tiponotificacao) : new Tiponotificacao();
        this.tipo_notificacao = tipo_notificacao ? new Tiponotificacao(tipo_notificacao) : new Tiponotificacao();
        this.status_remessa_correio = status_remessa_correio ? new StatusRemessaCorreio(status_remessa_correio) : new StatusRemessaCorreio();

        this.dom_publicacao_lote = dom_publicacao_lote && Array.isArray(dom_publicacao_lote) && dom_publicacao_lote.length > 0 ? dom_publicacao_lote.map(dom => {return new DomPublicacaoLote(dom)}) : [];

        //Visualização Log Erro Notificação
        this.disable_fields = disable_fields;
        this.num_ait_composto = num_ait_composto;
    }
}

export default LoteRemessaCorreio;